import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
import { Card } from './ui/Card';
import { TropicalLeaf } from './botanical/TropicalLeaf';
export function PainSection() {
  const pains = ['Dolor de garganta a la noche y sin jarabe en casa', 'Panza inflamada después de comer y sin saber qué tomar', 'Tu hijo con tos y vos buscando en Google sin resultado', 'Estrés acumulado y sin ningún recurso para calmarlo', 'Corriendo a la farmacia por cosas que podrías resolver en casa', 'Improvisando cada vez que aparece algo'];
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-310">
      <TropicalLeaf className="absolute bottom-0 -right-32 w-[500px] h-[500px] text-moss opacity-5 blur-lg -rotate-45" data-id="element-311" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-312">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-6 text-balance" data-id="element-313">
          ¿Cuántas noches más vas a quedarte sin saber qué hacer?
        </h2>

        <div className="text-lg text-forest/80 text-center mb-10 space-y-4" data-id="element-314">
          <p data-id="element-315">
            Tenés una familia. Tenés una casa. Pero nadie te enseñó qué hacer
            cuando aparece un malestar a las 2 de la mañana.
          </p>
          <p className="font-medium text-forest-deep" data-id="element-316">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </div>

        <Card className="p-6 md:p-8 bg-white/90 backdrop-blur-sm mb-10 border-sage-mist" data-id="element-317">
          <ul className="space-y-4" data-id="element-318">
            {pains.map((pain, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-319">
                <div className="mt-1 bg-terracotta/10 rounded-full p-1 shrink-0" data-id="element-320">
                  <X className="w-4 h-4 text-terracotta" data-id="element-321" />
                </div>
                <span className="text-forest-deep md:text-lg" data-id="element-322">{pain}</span>
              </li>)}
          </ul>
        </Card>

        <p className="text-2xl font-serif font-bold text-forest-deep text-center italic" data-id="element-323">
          ¿Y si esta fuera la última noche que terminás así?
        </p>
      </div>
    </Section>;
}